import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { LOGO } from "@/data/content";

const links = [
  { label: "Accueil", id: "accueil" },
  { label: "Prestations", id: "prestations" },
  { label: "Parfums", id: "parfums" },
  { label: "Toppings & Coulis", id: "toppings" },
  { label: "Galerie", id: "galerie" },
  { label: "FAQ", id: "faq" },
  { label: "Contact", id: "contact" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => { scrollTo(id); setOpen(false); };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/85 backdrop-blur-xl shadow-soft border-b border-beige" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto pl-2 pr-5 sm:pl-3 sm:pr-8 flex items-center justify-between h-24">
        <button data-testid="logo-btn" onClick={() => go("accueil")} className="flex items-center gap-2">
          <img src={LOGO} alt="Logo Moum's glace à l'italienne" className="h-20 w-20 sm:h-24 sm:w-24 object-contain" />
          <span className="font-heading text-3xl sm:text-4xl font-semibold text-chocolate">Moum's</span>
        </button>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-cocoa hover:text-strawberry transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="header-devis-btn"
          onClick={() => go("devis")}
          className="hidden sm:inline-flex items-center rounded-full bg-strawberry px-6 py-2.5 text-sm font-semibold text-white shadow-soft hover:bg-[#B83044] hover:scale-105 transition-all"
        >
          Demander un devis
        </button>

        <button data-testid="menu-toggle" className="lg:hidden text-chocolate" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white/95 backdrop-blur-xl border-t border-beige px-5 py-4 flex flex-col gap-2">
          {links.map((l) => (
            <button key={l.id} data-testid={`mobile-nav-${l.id}`} onClick={() => go(l.id)} className="text-left py-2 text-cocoa font-medium hover:text-strawberry">
              {l.label}
            </button>
          ))}
          <button data-testid="mobile-devis-btn" onClick={() => go("devis")} className="mt-2 rounded-full bg-strawberry px-6 py-3 text-sm font-semibold text-white">
            Demander un devis
          </button>
        </div>
      )}
    </header>
  );
};
